import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PageRequest, PageResponse, Template } from '../models/template.model';
import { Account } from '../models/account.model';

@Injectable({
  providedIn: 'root'
})

export class AccountRestService {
  private http = inject(HttpClient);
  private readonly apiUrl = environment.apiRestUrl;

  async getAccounts(request: PageRequest, search?: string, company?: string) {
    let params = new HttpParams()
    .set('page', request.page.toString())
    .set('size', request.size.toString());

    if (request.sort && request.sort.length > 0) {
      request.sort.forEach(sortParam => {
        params = params.append('sort', sortParam);
      });
    }

    if(search) {
      params = params.append('search', search)
    }

    if(company) {
      params = params.append('company', company)
    }

    return firstValueFrom(
      this.http.get<PageResponse<Account>>(`${this.apiUrl}/account/all`, { params })
    );
  }
}
